import { render, staticRenderFns } from "./HolidayCreate.vue?vue&type=template&id=b0ade07a&"
import script from "./HolidayCreate.vue?vue&type=script&lang=js&"
export * from "./HolidayCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports